export const toContentLanguage = (isoLang: string) => isoLang.toUpperCase().replace('-', '_');
